import PropTypes from 'prop-types';
import React from 'react';
import {createMuiTheme} from '@material-ui/core/styles';
import {blue} from '@material-ui/core/colors';

// The following URL shows the defaults for the various mui components
// https://github.com/callemall/material-ui/blob/master/src/styles/getMuiTheme.js#L31

import Base from 'common/components/Base';

import styles from 'ondemand/components/OndemandBase.css'; // eslint-disable-line no-unused-vars

const theme = {
  palette: {
    primary: {main: blue[500]},
    secondary: {main: blue[500]},
  },
};

const muiTheme = createMuiTheme(theme);


const OndemandBase = ({children}) => {
  return (
    <Base muiTheme={muiTheme}>
      {children}
    </Base>
  );
};

OndemandBase.propTypes = {
  children: PropTypes.node,
};

export default OndemandBase;



// WEBPACK FOOTER //
// ./src/ondemand/components/OndemandBase.js